import React, { FC } from 'react';
import { ReactComponent as IconDone } from './img/iconDone.svg';
import styles from './FilterButton.module.scss';

export interface FilterButtonProps {
  onClick: () => void;
  variant?: 'reset' | 'apply';
  children: React.ReactNode;
  disabled?: boolean;
}

export const FilterButton: FC<FilterButtonProps> = ({
  onClick,
  variant = 'apply',
  children,
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={variant === 'reset' ? styles.resetBtn : styles.applyBtn}>
      {children}
      {variant === 'apply' && <IconDone />}
    </button>
  );
};
